<div class="row mb-3">
  <div class="col-12">
    <h2>Thanks, your registration is complete!</h2>
  </div>
</div>
<div class="row mb-1">
  <div class="col-12">
    <p>
      Your academic email address has been verified. We will now check your registration. Once verified, we will send you a confirmation email with more
      information to <span class="email word-break-all">{{ email$ | async }}</span
      >.
      <br />
      In the meantime, feel free to download, install and share {{ productName$ | async }} and make use of the free trial.
    </p>
  </div>
</div>
<ng-container *yatVar="product$ | async as product">
  <ng-container *ngIf="(product?.productPaths ?? []).length > 0">
    <div class="row mb-3 mt-2">
      <div class="col-12">
        <h2>Download and install {{ productName$ | async }}</h2>
      </div>
    </div>
    <div class="col-12 mb-2">
      <yat-download-button-group
        [productPaths]="product?.productPaths ?? null"
        [showDownloadOverviewPanel]="true"
        [productName]="(productName$ | async) ?? ''"
        yatAutoFocus>
      </yat-download-button-group>
    </div>
    <div class="row mb-4 pt-1">
      <div class="col-12">
        <p class="font-small c-gray text-center terms">
          For more information about download and installation<br />
          options, visit our
          <a yat-link [yatExternalLink]="(getDownloadOverviewPath() | async) ?? ''" class="link link-secondary link-underline">download section</a>.
        </p>
      </div>
    </div>
  </ng-container>
</ng-container>
<div class="row mb-0">
  <div class="col-12">
    <button yat-button type="button" class="btn btn-large primary w-100" (click)="close()">Close</button>
  </div>
</div>
